import React from "react";
import TrendingNewsCard from "./TrendingNewsCard";
import BaseCarousel from "../../../components/ui/carousels/common/BaseCarousel";

function TrendingNewsCarousel({
  items = [],
  isLoading = false,
  onSeeAllClick,
}) {
  if (!isLoading && (!items || items.length === 0)) {
    return null;
  }

  // Ensure carousel displays max 10 items
  const limitedItems = items.slice(0, 10);

  const carouselItems = [
    ...limitedItems,
    { isSeeAllCard: true, id: "trending-see-all-card" },
  ];

  return (
    <BaseCarousel
      title="Trending News"
      items={carouselItems}
      isLoading={isLoading}
      showBorder={false}
      containerClassName="trending-news-carousel"
      renderItem={(item, index) => {
        if (item.isSeeAllCard) {
          return (
            <div key="see-all-card" className="trending-news-see-all-card">
              <button
                type="button"
                className="cta-button secondary rounded small"
                onClick={onSeeAllClick}
              >
                <b>SEE ALL</b>
              </button>
            </div>
          );
        }

        return (
          <TrendingNewsCard key={item.uuid || item.id || index} item={item} />
        );
      }}
    />
  );
}

export default TrendingNewsCarousel;
